// extracted by mini-css-extract-plugin
export var cardWrapper = "_48-0";